// extracted by mini-css-extract-plugin
export default {"grid":"styles__grid___FVQ8H","gridRowSpacing":"styles__gridRowSpacing___xOiz2","gridColSpacing":"styles__gridColSpacing___xkTsc"};